import './highlights.component.scss'

import MagicGrid from 'magic-grid'

class HighlightFilter {
  constructor(el, head) {
    this.elements = {
      main: el,
      head
    }

    this.init()
  }

  toggle() {
    this.elements.main.classList.toggle('opened')
  }

  defineEvents() {
    this.elements.head.addEventListener('click', this.toggle.bind(this))
  }

  init() {
    this.defineEvents()
  }
}

const highlightFiltersList = document.querySelectorAll('.highlights-filter')
highlightFiltersList.forEach(filter => {
  new HighlightFilter(filter, filter.querySelector('.highlights-filter__head'))
})

// const highlightList = document.querySelector('.highlights__list')
// if (highlightList) {
//   const magicGrid = new MagicGrid({
//     container: highlightList,
//     static: true,
//     gutter: 24,
//     maxColumns: 3, 
//   })
  
//   magicGrid.listen()
// }